import { render, staticRenderFns } from "./PutawayRuleBasedTemplate.vue?vue&type=template&id=bb6ca062"
import script from "./PutawayRuleBasedTemplate.vue?vue&type=script&lang=js"
export * from "./PutawayRuleBasedTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports